<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>

        <router-link class="admin-link"
            :to="{ path: `/Admin/Tags/StandardsBook`, query: { 'api-Version': apiHeaders['api-Version'] } }"
        >
            &larr; Перейти к списку тегов
        </router-link>

        <div class="admin-title">{{header}}</div>

        <b-tabs content-class="mt-3">

            <b-tab active title="Основная информация">

                <b-row class="mb-20">
                    <label for="nameTag">Введите название тега</label>
                    <b-form-input id="nameTag" v-model="entity.Name" />
                </b-row>

                <b-row class="mb-20">
					<b-col class="p-0">
						<label for="yesno">Это метатег?</label>
						<yes-no-input v-model="entity.IsParent"
									  id="yesno"
                                      :is-disabled="id != null"
									  @click="clearEntity" />
					</b-col>

					<b-col v-if="!entity.IsParent" class="p-0" cols="10">
                        <label for="selParent">Закрепить за метатегом?</label>
                        <custom-multiselect id="selParent"
                                            v-model="entity.ParentId"
                                            :options="parentTags"
                                            placeholder="Выберите метатег"
                                            open-direction="bottom"/>
					</b-col>

                    <b-col v-else class="p-0" cols="10">
                        <label for="selParent">Подчиненные теги</label>
                        <custom-multiselect id="selParent"
                                            v-model="entity.SubTags"
                                            :options="subTags"
                                            :multiple="true"
                                            placeholder="Выберите подчиненные теги"
                                            open-direction="bottom"/>
					</b-col>

				</b-row>

                <b-row v-if="!entity.IsParent" class="mb-20">
					<label for="fixingTag">Выберите книги стандартов</label>
					<custom-multiselect id="fixingTag"
                                        v-model="standardBooksWithoutNull"
                                        :options="standardBooks"
                                        :multiple="true"
                                        placeholder="Выберите книги стандартов" 
                                        :close-on-select="false"
                                        :clear-on-select="false"/>
				</b-row>	

            </b-tab>
			
            <b-tab :title="entity.IsParent ? 'Подчиненные теги' : 'Книги стандартов тега' ">

                <sorting-entities v-if="entity.IsParent"
                                  v-model="entity.SubTags"
                                  :options="subTags"
                                  :open-link="editLink" 
                                  :apiVersion="apiHeaders['api-Version']"/>

                <sorting-entities v-else 
                                  v-model="entity.StandardBooks"
                                  :options="standardBooks"
                                  :open-link="editLink" 
                                  :apiVersion="apiHeaders['api-Version']"/>

            </b-tab>            
        </b-tabs>

        <hr class="my-4">

		<b-row class="m-0">

            <b-col cols="2" class="p-0 mr-10">
			    <b-button block 
                          id="admin-btn-save"
                          class="admin-button"    
                          @click="saveTag">
                    Сохранить
                </b-button>
            </b-col>

            <b-col cols="2" class="p-0">
			    <b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button" 
                          @click="deleteTagDialog">
                    Удалить
                </b-button>
            </b-col>

		</b-row>

    </b-container>

</template>
<script>

import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import ApiHeaders from '@/store/models/ApiHeaders'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import YesNoInput from '@/components/shared/YesNoInput'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import SortingEntities from '@/components/admin/tags/SortingEntities'

import StandardBookEditTagModel from '@/store/models/admin/tags/StandardBookEditTag'

export default {
    data: function() {

        let entityTemp;

        let load = new Loading();

        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);

        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;

        if(id) 
            this.getTag(id, load, apiHeaders)
        else {
            this.getAllInfoStandardBook(load, apiHeaders);
            entityTemp = new StandardBookEditTagModel(null);
        }
            
        return {
            load: load,
            apiHeaders: apiHeaders,
            id: id,
            entity: entityTemp,

            subTags: [],
            parentTags: [],
            standardBooks: []
        }
    },
    computed: {
        header: function() {
            return this.id == null
                ? "Создание нового тега"
                : "Редактирование тега";
        },
        standardBooksWithoutNull: {
            get: function() {
                return this.entity.StandardBooks.filter(e => e != null);
            },
            set: function(value) {
                this.entity.StandardBooks.splice(0);
                value.forEach((e) => {
                    this.entity.StandardBooks.push(e);
                });
            }
        },
        editLink: function() {
           return this.entity.IsParent 
                    ? "/Admin/Tags/StandardsBook/Edit" 
                    : "/Admin/StandardBooks/Edit";
        }
    },
    methods: {
        getTag: function(id, load, apiHeaders) {
            load.Calculate(true);					
            apiService.Admin.Tags.StandardsBook.GetTag(id, apiHeaders)
                .then(response => {
                    this.entity = new StandardBookEditTagModel().mapFromDto(response.data);
                    this.getAllInfoStandardBook(load, apiHeaders);
                    load.Calculate(false);					
                })				
                .catch(error => load.Calculate(false));
		},
        getAllInfoStandardBook: function(load, apiHeaders) {
            load.Calculate(true);	

            apiService.Admin.Tags.StandardsBook.GetAllInfo(apiHeaders)
                .then(response => {
                    this.subTags = response.data.SubTags;
                    this.parentTags = response.data.ParentTags;                    
                    this.standardBooks = response.data.StandardBooks;

                    if(this.id)
                        this.getEntityObjects();

                    load.Calculate(false);	
                })
                .catch(error => load.Calculate(false));
        },
        getEntityObjects: function() {
            this.entity.ParentId = this.entity.ParentId ? this.parentTags.find(e => e.Id == this.entity.ParentId) : null;
            
            this.entity.IsParent
                    ? this.entity.SubTags = this.subTags.filter(e => this.entity.SubTags.some(s => s == e.Id))
                    : this.entity.StandardBooks = this.standardBooks.filter(e => this.entity.StandardBooks.some(s => s == e.Id));                
        },
        clearEntity: function() {
            this.entity.SubTags = [];
            this.entity.ParentId = null;
            this.entity.StandardBooks = [];   
        },
        saveTag: function() {
            if(this.entity.isInValid()){
                dialogService.showAlert('Предупреждение', 'Необходимо заполнить все поля.')
                return;
            }
            
            let tagDto = this.entity.mapToDto();

            this.load.Calculate(true);
            apiService.Admin.Tags.StandardsBook.PostEdit(tagDto, this.apiHeaders)
                
                .then(response => {
                    this.$router.push({ path: AllRoutes.Admin.Tags.StandardsBook.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } })
                })
                .catch(error => this.load.Calculate(false));
        },

        deleteTagDialog: function(){          
            if(!this.id) 
                this.$router.push({ path: AllRoutes.Admin.Tags.StandardBooks, query: { 'api-Version': this.apiHeaders['api-Version'] } })

            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный тег?')
                .then(ok => {
                    this.deleteTag(this.apiHeaders);
                })
                .catch(cancel => {})
        },
        deleteTag: function(apiHeaders) {
            this.load.Calculate(true);

            apiService.Admin.Tags.StandardsBook.PostDelete(this.id, apiHeaders)
                .then(response => {
                    this.$router.push({ path: AllRoutes.Admin.Tags.StandardsBook.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } })   
                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        YesNoInput,
        CustomMultiselect,
        SortingEntities
    }
}
</script>

